// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(), .breadcrumb-container {
   margin-right: 10px;
   max-height: 100%;
   overflow: hidden;
   text-overflow: ellipsis;
   flex: 1;
   min-width: 1px;
}

.breadcrumb1 {
   line-height: 30px;
   overflow: hidden;
   white-space: nowrap;
}

.div-header-chk-all {
   display: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/breadcrumb/breadcrumb.component.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;GAClB,gBAAgB;GAChB,gBAAgB;GAChB,uBAAuB;GACvB,OAAO;GACP,cAAc;AACjB;;AAEA;GACG,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;AACnB","sourcesContent":[":host(), .breadcrumb-container {\n   margin-right: 10px;\n   max-height: 100%;\n   overflow: hidden;\n   text-overflow: ellipsis;\n   flex: 1;\n   min-width: 1px;\n}\n\n.breadcrumb1 {\n   line-height: 30px;\n   overflow: hidden;\n   white-space: nowrap;\n}\n\n.div-header-chk-all {\n   display: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
